import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Article } from 'src/app/models/article';
import { AuthServiceService } from 'src/app/services/auth-service.service';
import { CartService } from 'src/app/services/cart.services';
import { CAtegorieService } from 'src/app/services/categorie.services';
import { ScriptLoaderService } from 'src/app/services/script-loader.services';
import { WishlistService } from 'src/app/services/wishlist.service';

declare var bootstrap: any;
@Component({
  selector: 'app-wishlist',
  templateUrl: './wishlist.component.html',
  styleUrls: ['./wishlist.component.css']
})
export class WishlistComponent implements OnInit {
  wishlistItems: any[] = [];
  isModalOpen: boolean = false;
  itemToRemove: number | null = null;
  selectedArticle: any = null;
  quantity: number = 1;
affichdetails=false;
displayedItems: any[] = []; // Articles affichés
itemsPerPage: number = 12; // Nombre d'articles à afficher par page
currentPage: number = 1; // Page courante
filteredItems: Article[] = []; // Articles filtrés
categories: any[] = []; // Liste des catégories dynamiques
selectedCategory: string = '';
  searchKeyword: string = '';
  dropdownOpen: boolean = false; // État du menu déroulant
  selectedTeinte: string = ''; // Libellé de la teinte sélectionnée
  selectedVariant: any;
cartItems: any[] = [];
 wishlistCount: number = 0;
  cartCount: number = 0;
  scripts = [
    'assets/js/jquery.min.js',
    'assets/js/bootstrap.min.js',
    'assets/js/swiper-bundle.min.js',
    'assets/js/carousel.js',
    'assets/js/bootstrap-select.min.js',
    'assets/js/lazysize.min.js',
    'assets/js/count-down.js',
    'assets/js/wow.min.js',
    'assets/js/multiple-modal.js',
    'assets/js/nouislider.min.js',
    'assets/js/shop.js',
    'assets/js/main.js',
    'assets/js/drift.min.js',            // ✅ manquant
    'assets/js/model-viewer.min.js',     // ✅ manquant
    'assets/js/zoom.js'                  // ✅ manquant
  ];



  constructor(private wishlistService: WishlistService, private authService: AuthServiceService ,  private scriptLoader: ScriptLoaderService, private categorieService: CAtegorieService,  private cartService: CartService,private router: Router ) { }

  ngOnInit(): void {
    this.scriptLoader.loadScripts(this.scripts);
      this.wishlistService.wishlist$.subscribe(wishlist => {
      this.wishlistCount = this.wishlistService.getWishlistCount();
    });
     this.cartService.cart$.subscribe(cart => {
      this.cartItems = cart;
      this.cartCount = cart.reduce((total, item) => total + item.quantity, 0);
    });
    this.loadCategories();
    console.log('searchKeyword initial :', this.searchKeyword);
    this.loadWishlistItems();
  }
  toggleDropdown(): void {
    this.dropdownOpen = !this.dropdownOpen; // Basculer entre ouvert et fermé
  }
  loadCategories(): void {
    this.categorieService.getCategories().subscribe((categories: any[]) => {
      this.categories = categories;
      console.log('Catégories chargées :', this.categories);
    });
  }
  goToProduct(articleId: number, libelle: string): void {
    if (!articleId || !libelle) {
      console.error("Erreur : ID ou libellé manquant !");
      return;
    }
    const formattedLibelle = libelle.toLowerCase().replace(/ /g, '-');
    const url = `/singleproduct/${formattedLibelle}/${articleId}`;
    console.log("Navigating to:", url);
    this.router.navigate([url]);
  }
  loadWishlistItems(): void {
    this.wishlistItems = this.wishlistService.getWishlistItems();
    console.log('Articles chargés :', this.wishlistItems);

    this.filteredItems = this.wishlistItems;
    this.updateDisplayedItems();
  }


  updateDisplayedItems(): void {
    const startIndex = 0;
    const endIndex = this.currentPage * this.itemsPerPage;

    // Toujours partir des articles filtrés pour appliquer la pagination
    this.displayedItems = this.filteredItems.slice(startIndex, endIndex);

    console.log('Articles affichés après mise à jour :', this.displayedItems);
  }


  // Charge plus d'articles lorsque l'utilisateur clique sur "Load More"
  loadMore(): void {
    this.currentPage++;
    this.updateDisplayedItems();
  }
  filterItems(): void {
    console.log('Recherche déclenchée :', this.searchKeyword);

    this.currentPage = 1; // Réinitialiser la page à 1 pour la recherche

    if (this.searchKeyword.length >= 3) {
      console.log('Mot-clé valide (3 lettres ou plus) :', this.searchKeyword);

      // Filtrer les articles si le mot-clé contient au moins 3 lettres
      this.filteredItems = this.wishlistItems.filter((item) =>
        item.libelle.toLowerCase().includes(this.searchKeyword.toLowerCase())
      );

      console.log('Articles filtrés :', this.filteredItems);
    } else {
      console.log('Moins de 3 lettres, réinitialisation des articles.');

      // Réinitialiser les articles filtrés si moins de 3 lettres
      this.filteredItems = this.wishlistItems;
    }

    this.updateDisplayedItems(); // Mettre à jour les articles affichés
    console.log('Articles affichés après filtre :', this.displayedItems);
  }
  selectCategory(category: any): void {
    this.selectedCategory = category.libelle; // Utilisez l'attribut correspondant au nom de la catégorie
    console.log('Catégorie sélectionnée :', this.selectedCategory);
    this.filterItems(); // Réappliquez le filtre avec la catégorie sélectionnée
  }

  filterByCategory(category: string): void {
    console.log('Filtrage par catégorie déclenché :', category);

    // Vérifiez si une catégorie est sélectionnée
    if (!category) {
      console.log('Aucune catégorie sélectionnée, réinitialisation des articles.');
      this.filteredItems = this.wishlistItems; // Réinitialisation
    } else {
      this.selectedCategory = category; // Mise à jour de la catégorie sélectionnée

      // Filtrage basé sur l'objet category.libelle
      this.filteredItems = this.wishlistItems.filter(
        (item) => item.category && item.category.libelle === this.selectedCategory
      );

      console.log('Articles filtrés par catégorie :', this.filteredItems);
    }

    this.updateDisplayedItems(); // Appliquer la pagination
  }




  openModal(itemId: number): void {
    this.isModalOpen = true;
    this.itemToRemove = itemId;
  }

  closeModal(): void {
    this.isModalOpen = false;
    this.itemToRemove = null;
  }

  confirmRemove(itemId: number): void {
    this.itemToRemove = itemId;
      this.removeFromWishlist(this.itemToRemove);
      this.closeModal();

  }
  addToCart(event: Event, product: any, quantity: number): void {
    event.preventDefault();

    if (product.details_variant?.length > 0 && !this.selectedTeinte) {

        return;
    }

    const updatedProduct = { ...product };
    let variant = null;

    if (this.selectedTeinte) {
        const selectedVariant = product.details_variant.find((v: any) => v.libelle === this.selectedTeinte);

        if (selectedVariant) {
            // Gestion spécifique des images en base64
            if (selectedVariant.images && selectedVariant.images.length > 0) {
                // Convertir le tableau de strings en tableau d'objets {data: string}
                updatedProduct.images = selectedVariant.images.map((img: string) => ({ data: img }));
            } else {
                // Fallback aux images originales si pas d'images spécifiques
                updatedProduct.images = [...product.images];
            }

            updatedProduct.libelle = `${product.libelle} - ${selectedVariant.libelle}`;
            updatedProduct.description = selectedVariant.description || product.description;
            updatedProduct.plus_details = selectedVariant.plus_details || product.plus_details;
            updatedProduct.selectedColor = selectedVariant.libelle;
            variant = selectedVariant.libelle;
        }
    }

    this.cartService.addToCart(updatedProduct, quantity, variant);
    this.loadCartItems();
    this.openCartManuellement();


}
openCartManuellement(): void {
  const modalElement = document.getElementById('shoppingCart');
  if (modalElement) {
    const modal = new bootstrap.Modal(modalElement);
    modal.show();
  }
}
 goToAccount(event: Event): void {
    event.preventDefault(); // évite le rechargement

    if (this.authService.getClientId() !== null) {
      this.router.navigate(['/account']);
    } else {
      this.router.navigate(['/login']);
    }
  }

loadCartItems(): void {
  this.cartItems = this.cartService.getCartItems();
}
  removeFromWishlist(itemId: number): void {
    this.wishlistService.removeFromWishlist(itemId);
    this.loadWishlistItems();

    if (this.wishlistItems.length === 0) {
      this.router.navigate(['/home']);
    }
  }
  showDetails(article: any) {
    this.selectedArticle = article;
    console.log(this.selectedArticle);
    this.affichdetails=true;
    console.log("hazemmm")
  }

  navigateToProductDetails(productId: number): void {
    this.router.navigate(['/singleproduct', productId]);
  }


    increaseQuantity() {
      if (this.quantity < this.selectedArticle?.stock) {
        this.quantity++;
      }
    }

    decreaseQuantity() {
      if (this.quantity > 1) {
        this.quantity--;
      }
    }


}
